export enum LDEnableNewBetUIVariant {
    TestVariantA = 'Var Control ~ Min Max Bet Tile Changes Not Displayed',
    TestVariantB = 'Var A ~ Min Max Bet Tile Changes Displayed',
}

export const LaunchDarklyShowNewBetUITileKey = 'ld9-live_casino_min_max_bet_tiles_bwin_dotcom_UK';

export const LDEnableNewBetUIMap = new Map<string, boolean>([
    [LDEnableNewBetUIVariant.TestVariantA, false],
    [LDEnableNewBetUIVariant.TestVariantB, true],
]);
